<template>
    <li class="flex flex-col w-full space-y-2 p-4 bg-indigo-50 rounded-md">
        <!-- Landlord Details -->
        <div class="flex flex-col">
            <div class="flex items-center justify-between">
                <div class="mr-1 font-normal flex items-center">
                    <span>{{ contact.full_name }}</span>
                    <icon-user :filled="true" title="Primary Contact" class="inline w-4 h-4 ml-2 -mt-0.5 text-gray-400" v-if="contact.pivot.primary == true"></icon-user>
                </div>

                <div class="text-right">
                    <div v-if="form.sent"
                         class="flex items-center p-2 leading-none text-sm rounded-md border-none font-medium text-green-600">
                        Email Sent
                    </div>
                    <button v-else
                            class="flex items-center p-2 leading-none text-sm rounded-md border-none font-medium transition duration-300"
                            :class="[reportWasSent ? 'text-green-600 hover:text-green-500' : 'text-indigo-600 hover:text-indigo-500']"
                            @click="sendLink"
                            :disabled="state.user.default_mailbox_id === null">
                        {{ getEmailButtonText() }}
                    </button>
                </div>
            </div>

            <span v-if="contact.email" class="text-indigo-600 text-xs font-normal" :class="{'text-red-500' : disableEmailOption}"> {{ contact.email }} </span>
        </div>

        <div class="flex flex-col space-y-2">
            <div v-if="!disableEmailOption">
                <saved-reply-notification-input type="email" :role="contact.pivot.role" @input="clearErrors(contact.pivot.role, 'email')"
                                                :to-email="contact && contact.email ? contact.email : null" category="inspections"
                                                v-model="form[contact.pivot.role + '_email_communication']" @toggle-edit-portal="toggleEditPortal()"
                                                :populate-for-contactable="{contactable_type: 'App\\Inspection', contactable_id: inspection.id, selectedContact: contact.id}">
                </saved-reply-notification-input>
                <span class="text-red-500 text-sm mt-1 flex justify-end"
                      v-if="form.errors.has(`${contact.pivot.role}_email_communication.custom_body`)">
                    {{ form.errors.get(`${contact.pivot.role}_email_communication.custom_body`) }}
                </span>
                <span class="text-red-500 text-sm mt-1 flex justify-end"
                      v-if="form.errors.has(`${contact.pivot.role}_email_communication.media`)">
                    {{ form.errors.get(`${contact.pivot.role}_email_communication.media`) }}
                </span>
            </div>
            <div v-else class="font-medium">Contact has no valid email address</div>
        </div>
        <span class="text-red-500 text-sm mt-1 flex justify-end"
              v-if="form.errors.has(`any_communication_selected`)">
            {{ form.errors.get(`any_communication_selected`) }}
        </span>
    </li>
</template>

<script>
import ContactCommunicationMixin from "../../mixins/contact-communication-mixin";

export default {
    name: "InspectionContact",

    props: {
        inspection: {
            type: Object,
            required: true
        },

        contact: {
            type: Object,
            required: true,
        },

        defaultCommunication: {
            type: Object,
            required: false
        }
    },

    mixins: [ContactCommunicationMixin],

    data () {
        return {
            form: new AppForm({
                sent: false,
                any_communication_selected: false,
                [this.contact.pivot.role + "_email_communication"]: null,
            }),
        };
    },

    computed: {
        reportWasSent () {
            return this.contact.pivot && this.contact.pivot.meta && this.contact.pivot.meta.inspection_report_link_sent;
        },

        disableEmailOption () {
            return this.validateContactEmail(this.contact);
        },
    },

    methods: {
        getEmailButtonText () {
            if (this.form.busy) {
                return "Sending Report...";
            }

            if (this.reportWasSent) {
                return "Resend Report";
            } else {
                return "Send Report";
            }
        },

        sendLink () {
            this.form.any_communication_selected = this.form[this.contact.pivot.role + "_email_communication"]?.custom_body?.length > 1;

            App.post("/inspections/" + this.inspection.id + "/sharing/email/" + this.contact.id, this.form)
            .then(response => {
                this.form.sent = true;
                toastr.success(response);
                this.$emit("report-sent", true);
            })
            .catch(error => {
                toastr.error(error.message);
            });
        },

        setContactCommunication () {
            // reset v-model
            this.form[this.contact.pivot.role + "_email_communication"] = {refresh: true};
            this.form[this.contact.pivot.role + "_sms_communication"] = {refresh: true};

            this.$nextTick(function () {
                this.form[this.contact.pivot.role + "_email_communication"] = this.disableEmailOption ? null :
                    _.cloneDeep(this.contact.pivot.role === "tenant" ? this.defaultCommunication.tenant_email : this.defaultCommunication.landlord_email);
            });
        },

        clearErrors (role, commType) {
            if (this.form.errors.has(`${role}_${commType}_communication.custom_body`)) {
                this.form.errors.forget(`${role}_${commType}_communication.custom_body`);
            }
        },

        toggleEditPortal () {
            this.$emit("show-portal-content");
        },
    }
};
</script>
